<template>

  <v-container>

    <v-sheet elevation="2" :class="{'px-3': isMobile, 'px-10': !isMobile }" class="py-8 mt-4 mb-8">

      <h1 class="headline text-center mb-4">{{ $t('nav.help') }}</h1>

      <div :class="{'green lighten-4': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }" class="mb-3 pa-5">
        <div class="text-center">{{ $t('feedbackForm.introTxt') }}</div>
        <div class="text-center mt-2"><strong>contact@ledgerdex.com</strong></div>
        <div class="text-center mt-2">
          <MailingList></MailingList>
        </div>
      </div>

      <div class="title mb-3">{{ $t('nav.aboutLedgerDex') }}</div>
      <AboutHelp class="mb-4" id="about-help">
      </AboutHelp>

      <div class="title mb-3">{{ $t('nav.myTokens') }}</div>
      <MyTokensHelp class="mb-4" id="my-tokens-help">
      </MyTokensHelp>

      <div class="title mb-3">{{ $t('ERC20TokenPage.title') }}</div>
      <TokenHelp class="mb-4" id="token-help">
      </TokenHelp>

      <div class="title mb-3">{{ $t('nav.marketplace') }}</div>
      <MarketplaceHelp class="mb-4" id="marketplace-help">
      </MarketplaceHelp>

      <div class="title mb-3">{{ $t('nav.createNewOrder') }}</div>
      <CreateOrderHelp class="mb-4" id="create-order-help">
      </CreateOrderHelp>

      <div class="title mb-3">{{ $t('nav.myOrders') }}</div>
      <MyOrdersHelp class="mb-4" id="orders-for-me-help">
      </MyOrdersHelp>

      <div class="title mb-3">{{ $t('nav.ordersForMe') }}</div>
      <OrdersForMeHelp class="mb-4" id="orders-for-me-help">
      </OrdersForMeHelp>

      <div :class="{'green lighten-4': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }" class="mb-3 pa-5">
        <div class="text-center">{{ $t('feedbackForm.introTxt') }}</div>
        <div class="text-center mt-2"><strong>contact@ledgerdex.com</strong></div>
        <div class="text-center mt-2">
          <MailingList></MailingList>
        </div>
      </div>

    </v-sheet>

  </v-container>

</template>

<script>
import AboutHelp from "@/components/help/AboutHelp"
import MyTokensHelp from "@/components/help/MyTokensHelp"
import TokenHelp from "@/components/help/TokenHelp"
import MarketplaceHelp from "@/components/help/MarketplaceHelp"
import OrdersForMeHelp from "@/components/help/OrdersForMeHelp"
import CreateOrderHelp from "@/components/help/CreateOrderHelp"
import MyOrdersHelp from "@/components/help/MyOrdersHelp"
import MailingList from "@/components/MailingList"

export default {
  name: 'Help',
  data () {
    return {
    }
  },
  components: {
    AboutHelp,
    MyTokensHelp,
    TokenHelp,
    MarketplaceHelp,
    CreateOrderHelp,
    MyOrdersHelp,
    OrdersForMeHelp,
    MailingList
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },
  },
  methods: {
  },
  created () {
  }
}
</script>


<style scoped>

</style>
